import { useQuery } from '@apollo/client';
import { GET_BOOKING_CALENDAR_LINKS } from '../util/gql';

export interface BookingCalendarLinks {
  googleCalendarUrl: string;
  icsUrl: string;
}

/**
 * The just-made booking's "Add to calendar" links, or null: while loading,
 * when `enabled` is false (not confirmed, staff booking), and whenever the
 * server has none to give (or does not know the query yet).
 */
export default function useBookingCalendarLinks(
  workOrderId: number | null | undefined,
  email: string | null | undefined,
  enabled: boolean,
): BookingCalendarLinks | null {
  const { data } = useQuery(GET_BOOKING_CALENDAR_LINKS, {
    variables: { workOrderId, email: email || null },
    skip: !enabled || !workOrderId,
    fetchPolicy: 'network-only',
  });
  const links = data?.bookingCalendarLinks;
  return links?.googleCalendarUrl && links?.icsUrl ? links : null;
}
